/** @jsx h */
import { h } from 'preact'

const JourneyNextButton = props => {
  const { url, inverse } = props

  return (
    <a class='JourneyNextButton' href={url}>
      <div class={`Arrow ${inverse ? 'Arrow--inverse' : ''}`} />
    </a>
  )
}

export default JourneyNextButton
